export default class ContactController {
  constructor(Contact) {
    'ngInject';
    this.Contact = Contact;
    this.contactRequest = {};
  }

  handleContactFormSubmit($event) {
    $event.preventDefault();
    this.contactRequest.submitted = true;

    this.Contact.sendRequest(this.contactRequest)
      .catch((response) => {
        let error = response.data.error;
        this.contactRequest.submitted = false;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/contact/contact.controller.js